import { Controller } from "stimulus"
export default class extends Controller {
    static targets = [ "option" ]
    change() {
        if (this.hasOptionTarget) {
            window.location.href = this.optionTarget.value;
          }
    }
}